import { Card, Divider, Select, Space, Typography } from 'antd'
import React, { useMemo } from 'react'
import ZCard from '../../Card/Index'
import { useDispatch, useSelector } from 'react-redux'
import { accountTypes } from '../../../utils/ConstantData'
import { useNavigate, useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import { setSelectedAccount } from '../../../store/reducers/slices/reportDetails.slice'
import { setAllOverviewData, setOverviewAccountDetails } from '../../../store/reducers/slices/overview.slice'
import EditPaperIcon from '../../../assets/icons/EditPaperIcon'
import { TabsEnum } from '../../../utils/Enum/ReportTabsEnum'
import { setTxnEndDate, setTxnStartDate } from '../../../store/reducers/slices/availableBalance.slice'

const SiderCard = ({ setActiveTab }) => {
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);
    const { summaryList } = useSelector(({ summary }) => summary);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();

    const selectedAcount = useMemo(() => {
        let data = {};
        if (reportDetails.reportAccounts && reportDetails.reportAccounts.length > 0) {
            data = reportDetails.reportAccounts.find((item) => item.account.accountId === selectedAccountId) || {};
        }
        return data;
    }, [reportDetails, selectedAccountId]);

    // console.log("SELECTED ACCOUNT::", selectedAcount);
    console.log("REPORT DETAILS SIDER::", reportDetails);

    const bankName = useMemo(() => {
        const bank = summaryList.find((item) => item.sectionName === "Bank Accounts" && item.setId === 2)?.setValue || "";
        // console.log("summaryList", bank, summaryList)
        return bank
    }, [summaryList]);

    const transactionDates = useMemo(() => {
        const transactionStartDate = summaryList.find((item) => item.sectionName === "Bank Accounts" && item.setId === 2)?.sectionValues
        return transactionStartDate
    }, [summaryList])

    // console.log("TXNDATES::", transactionDates);
    // console.log("USEMEMO::", dayjs(transactionDates?.find((item)=> item.key === "Txn Start Date").value).format("DD/MM/YYYY"));





    const accountListOption = useMemo(() => {
        let list = [];
        // list.push({value: '1', label:'All Bank Accounts'});
        if (reportDetails.reportAccounts && reportDetails.reportAccounts.length > 0) {

            list = reportDetails.reportAccounts.map((item) => {
                let accountElement = item.account;
                if (item.aaConsentDetails) {
                    accountElement = item.aaConsentDetails;
                }
                let accountTypeObj =
                    item.account &&
                    accountTypes.find(
                        ele =>
                            ele.name.toUpperCase() ===
                            item.account.accountTypeName.toUpperCase()
                    );
                console.log("LHHDKHKAHSAHSKFHKSAFKHFKH", item);
                

                return ({
                    value: accountElement.accountId,
                    label: `${item.aaConsentDetails
                        ? accountElement.bank.name
                        : accountElement.bankName
                        } - ${Boolean(accountElement.accountNumber)
                            ? accountElement.accountNumber
                            : accountElement.accountReferenceNumber
                        } ${accountTypeObj && accountTypeObj.id === 3
                            ? ' - OD / CC'
                            : accountTypeObj
                                ? ' - ' + accountTypeObj.title
                                : accountElement.accountTypeName
                                    ? ' - ' + accountElement.accountTypeName
                                    : ''
                        }`,
                        disabled: item?.account?.status === "NO TRANSACTIONS" ? true : false
                })
            })
        }



        const allBankNamesSame = reportDetails?.reportAccounts?.every((account, _, arr) => account.account.bankName === arr[0].account.bankName);

        if (list.length > 1 && reportDetails?.report?.precisaScore && allBankNamesSame === true) {
            list.unshift({ value: 'all', label: 'All Bank Accounts', disabled: reportDetails.reportAccounts?.find((item) => item?.account?.status === "NO TRANSACTIONS" )?.account?.status === "NO TRANSACTIONS" ? true : false });
        }
        console.log("LIST SIDER:>>>", list);
        return list;
    }, [reportDetails]);

    console.log("LIST SIDER:>>>", accountListOption, reportDetails.reportAccounts?.find((item) => item?.account?.status === "NO TRANSACTIONS" ));

    const handleChange = (value) => {
        console.log("SELECT ONCHANGE Value", value);
        
        dispatch(setAllOverviewData({
            overview: {},
        }))
        dispatch(setSelectedAccount(value));
        if (value === 'all') {
            setActiveTab(TabsEnum.SUMMARY);
            dispatch(setOverviewAccountDetails([]))
        }
    }

    const handleEdit = (event, record) => {
        console.log("EDIT REPORT RECORDS::", record);
        event.stopPropagation();
        navigate(`/reports/${record.reportId}/edit`);
    };

    // console.log("ACCOUNT OPTION :::::", accountListOption);

    // console.log("REPORT DETAILS ::::::", summaryList);



    return (
        <ZCard className='sider-card'>
            <Select
                className='mb-8'
                size={"large"}
                value={selectedAccountId}
                onChange={handleChange}
                style={{ width: "100%" }}
                options={accountListOption}
            />

            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>{/* <Space style={{gap:2}}> */}
                    <Space direction='horizontal' style={{ gap: "16px", width: "100%", justifyContent: "space-between" }}>
                        <Typography.Text className="report-label-text">Customer Name</Typography.Text>
                        <EditPaperIcon style={{ cursor: 'pointer' }} onClick={(event) => handleEdit(event, reportDetails?.report)} />
                    </Space>
                    {/* </Space> */}
                    <Typography.Text className='report-text'>{reportDetails?.report?.reportName || ""}</Typography.Text></>) : ""}
            </Space>

            {selectedAccountId === 'all' ? (<>
                <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                    <Space direction='horizontal'>
                        <Typography.Text className="report-label-text">Customer Name</Typography.Text>
                        <EditPaperIcon style={{ marginLeft: '129px', cursor: 'pointer' }} onClick={(event) => handleEdit(event, reportDetails?.report)} />
                    </Space>
                    <Typography.Text className='report-text'>
                        {reportDetails?.reportAccounts[0]?.account.accountHolderName || ""}
                    </Typography.Text>
                </Space>
            </>) : ""}
            <Space style={{ gap: 2 }} direction='vertical' className='w-100'>

                <Typography.Text className="report-label-text">Reference ID</Typography.Text>
                <Typography.Text className='report-text'>{params?.id || ""}</Typography.Text>

            </Space>
            {selectedAccountId !== 'all' ? (<>
                <Divider className='my-12' />
            </>) : ""}
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Description</Typography.Text>
                    <Typography.Text className='report-text'>{bankName}</Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Account Holder Name</Typography.Text>
                    <Typography.Text className='report-text'>
                        {
                            (selectedAcount.account && selectedAcount.account.accountHolderName && selectedAcount.account.jointHolderName)
                                ? selectedAcount.account.accountHolderName + ', ' + selectedAcount.account.jointHolderName
                                : (selectedAcount.account && selectedAcount.account.accountHolderName.trim())
                                    ? selectedAcount.account.accountHolderName
                                    : selectedAcount.account?.jointHolderName || '-'
                        }
                    </Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Account Number</Typography.Text>
                    <Typography.Text className='report-text'>{selectedAcount?.account?.accountNumber || ""}</Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Bank Name</Typography.Text>
                    <Typography.Text className='report-text'>
                        {
                            (selectedAcount && selectedAcount.aaConsentDetails) ? selectedAccountId.aaConsentDetails.bank.name : selectedAcount?.account?.bankName || ""
                        }
                    </Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Account Type</Typography.Text>
                    <Typography.Text className='report-text'>{(selectedAcount?.account?.accountType) && accountTypes.find((item) => item.id == selectedAcount?.account.accountType)?.title || ""}</Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Email</Typography.Text>
                    <Typography.Text className='report-text'>{selectedAcount?.account?.email || "-"}</Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Phone Number</Typography.Text>
                    <Typography.Text className='report-text'>{selectedAcount?.account?.phoneNumber || "-"}</Typography.Text>
                </>) : ""}
            </Space>
            {selectedAccountId !== 'all' ? (<>
                <Divider className='my-12' />
            </>) : ""}
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Statement From</Typography.Text>
                    <Typography.Text className='report-text'>{selectedAcount?.account?.startDate && dayjs(selectedAcount?.account?.startDate).format("DD/MM/YYYY") || ""}</Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Statement To</Typography.Text>
                    <Typography.Text className='report-text'>{selectedAcount?.account?.endDate && dayjs(selectedAcount?.account?.endDate).format("DD/MM/YYYY") || ""}</Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100 mb-8'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Txn Start Date</Typography.Text>
                    <Typography.Text className='report-text'>{transactionDates?.find((item) => item.key === "Txn Start Date").value && (transactionDates.find((item) => item.key === "Txn Start Date").value || "-")}</Typography.Text>
                </>) : ""}
            </Space>
            <Space style={{ gap: 2 }} direction='vertical' className='w-100'>
                {selectedAccountId !== 'all' ? (<>
                    <Typography.Text className="report-label-text">Txn End Date</Typography.Text>
                    <Typography.Text className='report-text'>{transactionDates?.find((item) => item.key === "Txn End Date").value && (transactionDates.find((item) => item.key === "Txn End Date").value || "-")}</Typography.Text>
                </>) : ""}
            </Space>
        </ZCard>
    )
}

export default SiderCard